import { Box, Stack, Grid, Button } from "@mui/material"
import { useState } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import MobileTicketInfo from "../../mobile/MobileTicketInfo";
import TicketChat from "../../mobile/MobileTicketMessageList";
import NewTicketUsers from "./NewTicketUsers";
import NewTicketMessageInput from "./NewTicketMessageInput";
import Iconify from "../../../../../../reusable-components/iconify";
import EditTicketSubject from "../../mobile/ticketInfo/EditTicketSubject";

MobileNewTicketView.propTypes = {
  possibleUsers: PropTypes.array,
  ticketTypeFieldGroups: PropTypes.array,
  selectedTicketType: PropTypes.object,
  ticketHtml: PropTypes.string,
  selectedFacility: PropTypes.object,
  setIsTicketMessagesEditorOpen: PropTypes.func,
  selectedTicketCategory: PropTypes.object,
  handleBackClick: PropTypes.func,
  ticketSubject: PropTypes.string,
  setTicketSubject: PropTypes.func,
  newUsers: PropTypes.array,
  setNewUsers: PropTypes.func,
}


export default function MobileNewTicketView({
  possibleUsers, ticketTypeFieldGroups, ticketHtml, selectedFacility, selectedTicketType, 
  setIsTicketMessagesEditorOpen, selectedTicketCategory, handleBackClick, ticketSubject, newUsers, setNewUsers, setTicketSubject
}) {

  const containerStyle = {
    borderRadius: 2,
    padding: 1,
    backgroundColor: 'white !important'
  }

  const { id } = useParams();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);

  return <Box sx={{height: '95%', maxHeight: '95%'}}>
    <Grid container alignItems="center" sx={{height: 'fit-content', minHeight: 0}}>
      <Grid item xs={2}>
        <Button
          onClick={() => {
            setIsTicketMessagesEditorOpen(false);
            handleBackClick();
          }}
          sx={{ minWidth: 0, px: 0 }}
        >
          <Iconify icon="mdi:chevron-left" />
        </Button>
      </Grid>
      <Grid item xs={8} sx={{ textAlign: 'center' }}>
        <EditTicketSubject
          ticketSubject={ticketSubject}
          setExternalTicketSubject={setTicketSubject}
          ticketSubjectSx={{ flex: 1 }}
        />
      </Grid>
      <Grid item xs={2}/>
    </Grid>
    <Stack direction="column" spacing={1.2} sx={{ height: '100%', margin: 'auto' }}>
      <Box sx={{ ...containerStyle, fontSize: '14px' }}>
        <NewTicketUsers setNewUsers={setNewUsers} newUsers={newUsers} possibleUsers={possibleUsers}/>
      </Box>
      {/* 350px accounts for keyboard height on mobile when input is focused */}
      <Box sx={{ ...containerStyle, height: isInputFocused ? 'calc(100% - 350px)' : '100%', alignContent: 'end'}}>
        {id ? <TicketChat newUsers={newUsers}/> :
        <NewTicketMessageInput
          ticketHtml={ticketHtml}
          selectedTicketType={selectedTicketType}
          ticketTypeFieldGroups={ticketTypeFieldGroups}
          newUsers={newUsers}
          selectedFacility={selectedFacility}
          ticketSubject={ticketSubject}
          selectedTicketCategory={selectedTicketCategory}
          setIsTicketInfoOpen={setIsDrawerOpen}
          possibleUsers={possibleUsers}
          setIsInputFocused={setIsInputFocused}
        />}
      </Box>
    </Stack>
    <MobileTicketInfo
      facility={selectedFacility}
      possibleUsers={possibleUsers}
      ticketUsers={newUsers}
      setNewUsers={setNewUsers}
      setIsTicketInfoOpen={setIsDrawerOpen}
      isTicketInfoOpen={isDrawerOpen}
      setExternalTicketSubject={setTicketSubject}
      ticketSubject={ticketSubject}
    />
  </Box>
}
